<div>
    <ul class="floor">
        <li class="flat-floor-set">
            <div class="list-flats">
                <app-flat-test @slideRightUp class="view-flat" *ngFor="let flat of filteredFlats; trackBy: trackById"
                               [buildUid]=buildUid
                               [flat]=flat
                               [build]=build
                               (showFloorPlanEmit)="showFloorPlanF($event)">
                </app-flat-test>
                <div class="emptyFilter" *ngIf="allFlats.length > 0 && filteredFlats.length === 0">
                    לא נמצאו דירות מתאימות, נסה לשנות את החיפוש
                </div>
            </div>
        </li>
    </ul>
</div>
